<template>
<div class="liveSet bgc">
    <div class="vliveHeader padding-20">
        <div class="vliveContent">
            <span>{{liveInfoData.subject}}</span>
            <span>{{liveInfoData.begintime}}</span>
        </div>
    </div>
    <div class="padding-20 playback-interface">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="直播导航" name="vliveContent">
                <vliveContent @setNavData="setNavData" class="padding-20"></vliveContent>
                <vliveExample :liveInfoData="liveInfoData" :navListData="navListData"></vliveExample>
            </el-tab-pane>
            <el-tab-pane label="引导封面" name="vliveGuideCover">
                <vliveGuideCover :liveInfoData="liveInfoData" @getLiveInfoData="_getView2" class="padding-20"></vliveGuideCover>
                <vliveExampleGuideCover :liveInfoData="liveInfoData"></vliveExampleGuideCover>
            </el-tab-pane>
            <el-tab-pane label="主办方信息" name="SponsorInformation">
                <SponsorInfo ref="SponsorInfocom"></SponsorInfo>
            </el-tab-pane>
        </el-tabs>

    </div>
</div>
</template>

<script>
import {getLiveInfo} from 'api/api'
import {urlToQRCode} from 'common/js/tools'
import VliveExample from 'views/cms/vlive/components/vliveExample2'
import VliveContent from 'views/cms/vlive/components/vliveContent2'
import VliveGuideCover from 'views/cms/vlive/components/vliveGuideCover2'
import VliveExampleGuideCover from 'views/cms/vlive/components/vliveExampleGuideCover2'
import SponsorInfo from 'views/cms/vlive/liveing/SponsorInfo'
import {getVliveHighSetting} from 'api/api'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'liveSet',
    data() {
        return {
            activeName: 'vliveContent',
            liveInfoData: {
                begintime: '',
                subject: '',
                vlivePreUrl: '',
                logoPic: {
                    furl: ''
                },
                posterurl: {
                    furl: ''
                }
            },
            navListData: [],
            param: {
                assetinnerid: this.$route.query.id ? this.$route.query.id : '' // id
            }
        }
    },
    created() {
        // this._getVliveModle()
        this._getView2()
    },
    mounted() {
        if (this.$route.query.tab) {
            this.activeName = this.$route.query.tab
        }
    },
    methods: {
        setNavData(data) {
            this.navListData = data
        },
        _getView2() {
            this.setLoading(true)
            getLiveInfo({
                data: {
                    innerid: this.$route.query.id
                },
                success: data => {
                    this.liveInfoData = data.data
                    this.liveInfoData.vlivePreUrl = urlToQRCode(this.liveInfoData.vlivePreUrl)
                    this.$refs.SponsorInfocom.setFormData(this.liveInfoData)
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        handleClick() {

        },
        _getVliveModle () {
            this.setLoading(true)
            getVliveHighSetting({
                data: this.param,
                success: data => {
                    let obj = data.data
                    let item = {
                        assetinnerid: obj.assetinnerid, // 直播ID
                        customerinnerid: obj.customerinnerid, //  会员ID
                        hostinnerid: obj.hostinnerid, //  发布方ID
                        banner: {
                            coverPicture: obj.logoPic
                        },
                        contentthemecolor: obj.contentthemecolor,
                        contentList: [],
                        weChatShare: {
                            sharesubject: obj.sharesubject,
                            sharedesc: obj.sharedesc,
                            coverPicture: obj.sharelogoPic
                        },
                        trailer: {
                            isopenpreview: !!obj.isopenpreview,
                            videoInfo: obj.previewVideo
                        },
                        guideCover: {
                            isopencover: !!obj.isopencover,
                            coverPicture: obj.coverPic
                        },
                        follow: {
                            isopenmp: !!obj.isopenmp,
                            coverPicture: obj.mplogoPic,
                            openmpname: obj.openmpname,
                            mpqrPic: obj.mpqrPic
                        },
                        adv: {
                            isopenad: !!obj.isopenad,
                            list: []
                        },
                        signUp: {
                            isopenenroll: !!obj.isopenenroll,
                            coverPicture: obj.enrolliconPic,
                            enrollurl: obj.enrollurl
                        }
                    }
                    if (this.vliveModel.contentList.length > 0) {
                        item.contentList = this.vliveModel.contentList
                    }
                    if (this.vliveModel.adv.list && this.vliveModel.adv.list.length > 0) {
                        item.adv.list = this.vliveModel.adv.list
                    }
                    this.setVliveModel(item)
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setVliveModel'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'vliveModel',
            'loading'
        ])
    },
    components: {
        VliveExample,
        VliveContent,
        VliveGuideCover,
        VliveExampleGuideCover,
        SponsorInfo
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.liveSet {
    // min-height: 840px;
    .vliveHeader {
        @include flexBox(space-between);
        border-left: 4px solid $bgcolor-base;
        border-bottom: 1px solid $line;
        .vliveContent{
            span{
                margin-right: 30px;
            }
        }
    }
    .playback-interface{
        position: relative;
        .vliveExample, .vliveExampleGuideCover{
            position: fixed;
            top: 150px;
            right: 0;
            z-index: 1000;
            .phone-model {
                box-sizing: border-box;
                width: 406px;
                height: 782px;
                padding: 143px 42px 0 46px;
            }
        }
    }
    .el-switch__label--right{
        color: $tcolor-grey;
    }
    .switch{
        font-size: $font-14;
        .el-switch{
            margin-left: 10px;
        }
        color: $tcolor-gray;
    }
    .el-switch.is-disabled{
        opacity: 1;
    }
    .el-switch.is-disabled .el-switch__core, .el-switch.is-disabled .el-switch__label{
        cursor: pointer;
    }
}
</style>
